import http from 'utils/http'
import headersBuilder from 'utils/login/basicHeadersBuilders'

// options.showSpinner=false keeps the global spinner off. The global spinner makes the
// signed-out landing page redirect to /Menu and back while the request runs (see
// userIsNotAuthenticatedRedir in src/auth.js), which unmounts the sign-in form.
const login = (credentials, options = {}) => {
  const urlLogin =
    !!credentials && !!credentials.staySigned
      ? `/user/v1/login?remember-me=true`
      : `/user/v1/login`
  return http.post(urlLogin, undefined, headersBuilder(credentials), false, options.showSpinner !== false)
}

const preLogin = (credentials, options = {}) =>
  http.post('/user/v1/login/pre-login', credentials, undefined, true, options.showSpinner !== false)

const logout = () => http.post('/user/v1/logout')

export default {
  login,
  preLogin,
  logout
}



// WEBPACK FOOTER //
// ./src/services/loginService.js